module.exports = __webpack_public_path__ + "PERUVIANhome-8.692d77f3.png";